import Modal from "../Modal";
import OpportunityNewForm from "../../forms/opportunity/OpportunityNewForm";
import {PartnerApi} from "../../../api/partner.api";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import { useTranslation } from "../../../hooks/useTranslation";

export default function OpportunityExportSNModal({
                                                   opportunity = null,
                                                   show,
                                                   handleClose,
                                                   title
                                               }) {
    const { t } = useTranslation();
    const token = useAuthStore((state) => state.token);

    return (
        <Modal title={title} show={show} handleClose={handleClose}>
            <div className="text-center">
            <button
                className="btn btn-success ms-2 mb-2"
                onClick={() =>
                    PartnerApi.download(
                        "/opportunity/" + opportunity.opportunity_id + "/export_sn.csv",
                        "prilezitost_sn_" + opportunity.opportunity_id + ".csv",
                        token
                    )
                }
            >
                <i className="ki-duotone ki-document fs-4 cursor-pointer">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>{" "}
                {t("opportunities.exportCsv")}
            </button>
            <button
                className="btn btn-success ms-2 mb-2"
                onClick={() =>
                    PartnerApi.download(
                        "/opportunity/" + opportunity.opportunity_id + "/export_sn.xlsx",
                        "prilezitost_sn_" + opportunity.opportunity_id + ".xlsx",
                        token
                    )
                }
            >
                <i className="ki-duotone ki-document fs-4 cursor-pointer">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>{" "}
                {t("opportunities.exportXlsx")}
            </button>
            </div>
        </Modal>
    );
};